export default __webpack_public_path__ + "static/media/shaivya.915b061e.jpeg";